<template>
    <div id="panel-4" class="panel">
        <div class="panel-hdr bg-danger-800 bg-success-gradient">
            <h2>
                {{ __t('LIST') }} <span class="fw-300"><i>{{__t('MODIFIER_GROUPS')}}</i></span>
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-icon btn-sm btn-danger mr-1 shadow-0 waves-effect waves-themed" v-on:click="clean">
                    <i class="fal fa-trash"></i>
                </button>

                <button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
                    <i class="fal fa-plus"></i>
                </button>


            </div>


        </div>
        <div class="panel-container show pt-1 pb-1">
            <div class="panel-content">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="rounded">
                        <!-- nav-menu-reset will reset the font colors -->
                        <ul class="nav-menu  mb-sm-4 mb-md-0 rounded " v-if="worked_orgs.length > 0">
                            <li v-for="org in worked_orgs" :class="{'show_children' : org.children_show}">
                                <a href="#" class="waves-effect waves-themed " :class="{'active_filter':is_active_org(org),}">
                                    <strong class="dl-ref bg-success-500" v-on:click.self="setActive(org)" v-if="org.published">active</strong>
                                    <strong class="dl-ref bg-danger-500" v-on:click.self="setActive(org)" v-if="!org.published">active</strong>

                                    <span class="nav-link-text color-black" v-on:click.self="setActive(org)">
                                        <div>
                                            <div class="position-relative">
                                                <span class="small text-info pl-2" v-if="org.overrides_count > 0">
                                                    <i title="GROUP_HAS_OVERRIDE" class="fal fa-sync"></i>
                                                </span>
                                                {{ get_group_title(org) }}

                                                <span class="small text-info">
                                                    <i class="fal fa-lock" v-if="org.skeep_sync"></i>
                                                </span>
                                            </div>
                                        </div>
								    </span>
                                    <i class="fal fa-cog width-2 fs-xxl ml-4" v-on:click.stop="edit(org)"></i>
                                </a>
                            </li>
                        </ul>
                        <div class="filter-message js-filter-message m-0 text-left pl-4 py-3 fw-500"></div>
                    </div>
                </b-overlay>
            </div>
        </div>

        <group_modal></group_modal>
    </div>
</template>

<script>
    import group_modal from "./group_modal.vue";

    export default {
        name: "modif_groups",
        components: {group_modal},

        data() {
            return {
                groups: [],
                is_load: true,
                is_show_modal: false,
                active_filter_org: []
            }
        },

        created () {
            EventBus.$on('reload_groups',this.load_groups);
            EventBus.$on('clean_modif_filter',this.clean_filter);
            this.load_groups();
        },

        methods : {

            get_group_title(grp) {
                if(grp.title.length > 0) {
                    return grp.title;
                }

                return this.__t("NO_TITLE");
            },

            create() {
                EventBus.$emit("group_edit", 0);
            },

            is_active_org(item) {
                let is_active = false;
                this.active_filter_org.map(id => {
                    if (parseInt(id) === parseInt(item.id)) {
                        is_active = true;
                    }
                });
                return is_active;
            },

            clean_filter() {
                this.active_filter_org = [];
            },

            edit(item) {
                EventBus.$emit("group_edit", parseInt(item.id));
            },

            clean() {
                let self = this;
                const is_ok = confirm_me(this.__t("ARE_SURE"));
                is_ok.then(res => {
                    api.delete('/internal/v1/catalog/modifiers/groups').then(({data}) => {
                        self.is_load = false;
                        if (data.status === "operation_success") {
                            EventBus.$emit('reload_groups');
                            EventBus.$emit("reload_modifiers");
                        }
                    }).catch(({response}) => {
                        self.is_load = false;
                        EventBus.$emit('show_toast', {
                            err: response.data.message, type: "danger",
                            title: response.data.status,
                            position : "b-toaster-top-left"
                        })
                    });
                });
            },

            setActive(item) {

                const id = parseInt(item.id);
                if (this.active_filter_org.includes(id)) {
                    this.active_filter_org = this.active_filter_org.filter(v => v !== id);
                } else {
                    this.active_filter_org.push(id);
                }

                this.$emit('input', this.active_filter_org);
                EventBus.$emit('modif_groups_changed', {
                    "type": "groups",
                    "value": this.active_filter_org
                });
            },

            async load_groups() {
                this.groups = [];
                this.is_load = true;

                await api.post('/internal/v1/catalog/modifiers/groups').then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.groups = data.data;
                        this.groups.map(item => {
                            item.is_active = false;
                        })

                    } else {
                        this.groups = [];
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    this.groups = [];
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            }
        },

        computed : {

            worked_orgs() {
                return this.groups;
            },
        }

    }
</script>

<style scoped>
    .categ_bg {
        background-color: #eeeeee2e;
    }

    .children_info {
        width: 15px;
        height: 15px;
        cursor: row-resize;
        text-align: center;
    }

    a.active_filter {
        border-left: 3px solid #584475;
        background: #eee;
    }

    li.show_children ul {
        display: block;
    }

</style>
